import { renderPrintDocument } from "../../core/renderPrintDocument";
import { escapeHtml } from "../../shared/escapeHtml";
import { officialDocumentStyles } from "../../shared/officialDocumentStyles";
import { createTankCertificatePrintViewModelV2 } from "./createTankCertificatePrintViewModelV2";

const tankCertificateStylesV2 = `
  ${officialDocumentStyles}
`;

const renderTankCertificateBody = (model, t) => `
  <main class="official-document">
    <header class="official-header">
      <div class="official-logo-wrap">
        ${
          model.companyLogo
            ? `<img src="${escapeHtml(model.companyLogo)}" alt="Company logo" class="official-logo" />`
            : ""
        }
      </div>
      <div class="official-header-main">
        <h1 class="official-vessel-name">${escapeHtml(model.vesselName)}</h1>
        <h2 class="official-title">${escapeHtml(model.title)}</h2>
      </div>
    </header>

    <hr class="official-rule" />

    <table class="official-meta" aria-label="Document metadata">
      <tbody>
        <tr>
          <td class="official-meta-label">Voy:</td>
          <td class="official-meta-value">${escapeHtml(model.voyageNumber)}</td>
          <td class="official-meta-label">${escapeHtml(t("forPrint.port"))}:</td>
          <td class="official-meta-value">${escapeHtml(
            model.jettyName ? `${model.portName} (${model.jettyName})` : model.portName
          )}</td>
        </tr>
        <tr>
          <td class="official-meta-label">${escapeHtml(t("forPrint.date"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.inspectionDate)}</td>
          <td class="official-meta-label">${escapeHtml(t("forPrint.time"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.inspectionTime)}</td>
        </tr>
        <tr>
          <td class="official-meta-label">${escapeHtml(t("forPrint.cargo"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.cargoName)}</td>
          <td class="official-meta-label"></td>
          <td class="official-meta-value"></td>
        </tr>
      </tbody>
    </table>

    <hr class="official-meta-separator" />

    <section class="official-section">
      <p class="official-paragraph">${escapeHtml(model.statement)}</p>
      <div class="official-box">
        <div class="official-emphasis">${escapeHtml(t("forPrint.cargoTanksNo"))}</div>
        <div class="official-chip-grid">
          ${model.selectedTanks
            .map((tank) => `<span class="official-chip">${escapeHtml(tank)}</span>`)
            .join("")}
        </div>
      </div>
      <p class="official-note">
        The undersigned have today inspected the above mentioned tanks and hereby confirm their condition as stated above.
      </p>
    </section>

    <section class="official-signatures">
      <div class="official-signature-block">
        <div class="official-signature-line"></div>
        <div class="official-signature-caption">
          <div>${escapeHtml(t("forPrint.shoreRepresentative"))}</div>
          <div class="official-signature-name">${escapeHtml(t("forPrint.nameInBlock"))}</div>
        </div>
      </div>
      <div class="official-signature-block">
        <div class="official-signature-line"></div>
        <div class="official-signature-caption">
          <div>${escapeHtml(t("forPrint.shipRepresentative"))}</div>
          <div class="official-signature-name">${escapeHtml(
            `${t("forPrint.chiefOfficer")}: ${model.chiefOfficer}`
          )}</div>
        </div>
      </div>
    </section>
  </main>
`;

export const renderTankCertificateV2 = (input) => {
  const model = createTankCertificatePrintViewModelV2(input);

  return renderPrintDocument({
    title: model.title,
    templateId: input.isCTC ? "ctc" : "etc",
    viewModel: model,
    styles: tankCertificateStylesV2,
    body: renderTankCertificateBody(model, input.t),
  });
};
